<template>
  <div class="footer">
    <div class="nav-footer">
      <div class="container">
        <div class="footer-weixin">
<!--          <a href="../pages/home.vue"></a>-->
          <span class="item-weixin"></span>
          <div class="item-word">扫一扫</div>
          <div class="item-word">关注公众号</div>
        </div>
        <div class="footer-cons">
          <div class="item-meun">
            <router-link to="/brandIntr" class="meun" active-class="nav">
              <span>品牌介绍</span>
            </router-link>
            <router-link  to="/classSystem" class="meun" active-class="nav">
              <span class="circal"></span><span>课程体系</span>
            </router-link>
            <router-link to="/teacherTeams" class="meun" active-class="nav">
              <span class="circal"></span><span>师资团队</span>
            </router-link>
            <router-link to="/studentStatus" class="meun" active-class="nav">
              <span class="circal"></span><span>学员动态</span>
            </router-link>
             <router-link to="/grading" class="meun" active-class="nav">
              <span class="circal"></span><span>官方考级</span>
            </router-link>
            <router-link to="/aboutUs" class="meun" active-class="nav">
              <span class="circal"></span><span>关于我们</span>
            </router-link>
            <router-link to="/yhxy" class="meun" active-class="nav">
              <span class="circal"></span><span>用户协议</span>
            </router-link>
            <router-link to="/yssm" class="meun" active-class="nav">
              <span class="circal"></span><span>隐私声明</span>
            </router-link>
            <router-link to="/bqsm" class="meun" active-class="nav">
              <span class="circal"></span><span>版权声明</span>
            </router-link>
          </div>
<!--          <template>-->
<!--            <div class="link-meun">-->
<!--              <router-link to="/yhxy" class="meun" active-class="nav">-->
<!--                <span>用户协议</span>-->
<!--              </router-link>-->
<!--              <router-link to="/yssm" class="meun" active-class="nav">-->
<!--                <span>隐私声明</span>-->
<!--              </router-link>-->
<!--              <router-link to="/bqsm" class="meun" active-class="nav">-->
<!--                <span>版权声明</span>-->
<!--              </router-link>-->

<!--              &lt;!&ndash;              <pdf src="../assets/pdf/yhxy.pdf" class="meun" active-class="nav">用户协议</pdf>&ndash;&gt;-->
<!--            </div>-->
<!--          </template>-->
          <div class="item-rigts">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" class="rights">2018-2020 @ 欢迎您访问弈小象 <img src="http://gw.alicdn.com/tfs/TB1jwakrbH1gK0jSZFwXXc7aXXa-20-20.png"/> ICP备案：京ICP备18064456号-1</a>
          </div>
        </div>
        <div class="footer-xiaochengxu">
          <!--          <a href="../pages/home.vue"></a>-->
          <span class="item-xiaochengxu"></span>
          <div class="item-word">扫一扫</div>
          <div class="item-word">关注小程序</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'NavFooter'
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .footer{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    background-color: $colorB;
    .nav-footer{
      width: 1180px;
      height: 240px;
      margin: auto;
      display: block;
      .container{
        width: 1180px;
        height: 100%;
        display: block;
        @include flex();
        align-items: center;
        .footer-weixin {
          width: 170px;
          text-align: center;
          margin-right: 117px;
          @media only screen and (min-width: 540px) and (max-width: 1180px){
            padding-left: 40px;
          }
          a{
            @include bgImg(170px,70px,"../assets/imgs/logo.png");
          }
          .item-weixin {
            width: 100px;
            height: 100px;
            @include bgImg(100px,100px,"../assets/imgs/weixin.jpg");
          }
          .item-xiaochengxu {
            width: 100px;
            height: 100px;
            @include bgImg(100px,100px,"../assets/imgs/xiaochengxu.jpg");
          }
          .item-word {
            font-size: $fontI;
            color: $colorD;
          }
        }
        .footer-cons {
          width: 50%;
          .item-meun{
            width: 100%;
            @include flex();
            text-align: center;
            .circal{
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: $colorD;
              line-height: 16px;
              align-items: center;
              margin-bottom: 2.1px;
              margin-right: 5px;
              box-sizing: border-box;
            }
            .meun{
              color: $colorD;
              font-size: $fontK;
            }
            .nav{
              color: $colorF;
            }
          }
          .item-rigts{
            width: 100%;
            margin-top:20px;
            color: $colorD;
            text-align: center;
            .rights{
              text-decoration: none;
              color: $colorD;
              img{
                margin-left: 10px;
                margin-right: 10px;
                vertical-align: middle;
              }
            }
          }
        }
        .footer-xiaochengxu {
          width: 170px;
          text-align: center;
          margin-left: 117px;
          @media only screen and (min-width: 540px) and (max-width: 1180px){
            padding-right: 40px;
          }
          a{
            @include bgImg(170px,70px,"../assets/imgs/logo.png");
          }
          .item-xiaochengxu {
            width: 100px;
            height: 100px;
            @include bgImg(100px,100px,"../assets/imgs/xiaochengxu.jpg");
          }
          .item-word {
            font-size: $fontI;
            color: $colorD;
          }
        }
      }
    }
    .footer-bottom {
      height: 50px;
      background-color: #4B5692;
      margin-top: 20px;
      .bottom {
        width: 1226px;
        margin: auto;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
        font-size: $fontI;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavFooter.vue